<template>
    <a-form :form="basicConfigForm" v-show="basicConfigStatus == 'process'">
        <a-form-item :label="$t('supervise.locateFreq')" v-bind="formItemLayout">
            <a-select size="small" :allowClear="true" :defaultValue="1800" v-model="locateFreq" style="width:100%">
                <a-select-option v-for="option in freqOptions" :key="option.key">{{option.label}}</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item :label="$t('supervise.autoAdjust')" v-bind="formItemLayout">
            <a-switch size="small" v-model="autoAdjust"/>
        </a-form-item>

        <a-form-item :label="$t('supervise.customLocate')" v-bind="formItemLayout">
            <a-switch size="small" :disabled="locateFreq == null" v-model="specialFreqSetting"/>
        </a-form-item>

        <a-row>
            <a-col span="22" v-if="specialFreqSetting && locateFreq != null" style="margin-bottom: 20px;margin-left:1%;">
                <a-row :gutter="24" style="border-left:1px solid #e9eaec;border-right:1px solid #e9eaec;border-bottom:1px solid #e9eaec;padding:10px">
                    <a-divider orientation="left" style="position:absolute;font-size:12px;margin-top:-8px;margin-left:-10px">{{$t('supervise.customLocate')}}</a-divider>

                    <a-form-item :label="$t('supervise.segmentTime')" v-bind="formItemLayout" :validateStatus="specialTimeValidateStatus" :help="specialTimeErrorMessage">
                        <a-time-picker @change="onTimeChange" :secondStep="60" size="small" style="width:40%" format="HH:mm:ss" v-model="startTime" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                        <a-input size="small" style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                        <a-time-picker @change="onTimeChange" :secondStep="60" size="small" style="width:40%" format="HH:mm:ss" v-model="endTime" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.segmentFreq')" v-bind="formItemLayout" :validateStatus="specialFreqValidateStatus" :help="specialFreqErrorMessage">
                        <a-select size="small" v-model="intervalTime" style="width:100%">
                            <a-select-option v-for="option in freqOptions" :key="option.key">{{option.label}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-row>
            </a-col>
        </a-row>

        <a-form-item :label="$t('supervise.autoPowerUp')" v-bind="formItemLayout" :validateStatus="powerUpValidateStatus" :help="powerUpValidateErrorMessage">
            <a-time-picker @change="onTimeChange" size="small" style="width:100%" format="HH:mm:ss" v-model="powerUpTime" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
        </a-form-item>

        <a-form-item :label="$t('supervise.autoPowerDown')" v-bind="formItemLayout" :validateStatus="powerDownValidateStatus" :help="powerDownValidateErrorMessage">
            <a-time-picker @change="onTimeChange" size="small" style="width:100%" format="HH:mm:ss" v-model="powerDownTime" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 3 }" style="margin-top:10px">
            <a-button style="margin-left:10px" @click="gotoPrevious">{{$t('global.pre')}}</a-button>
            <a-button style="margin-left:10px" type="primary" @click="gotoNext">{{$t('global.next')}}</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'ZAddBasicConfig',
        props:['basicConfigStatus'],
        data() {
            return {
                basicConfigForm: null,
                locateFreq: 1800,
                autoAdjust: true,
                specialFreqSetting: false,
                startTime: null,
                endTime: null,
                intervalTime: null,
                powerUpTime: null,
                powerDownTime: null,
                specialTimeValidateStatus: null,
                specialTimeErrorMessage:null,
                specialFreqValidateStatus: null,
                specialFreqErrorMessage : null,
                powerUpValidateStatus: null,
                powerUpValidateErrorMessage: null,
                powerDownValidateStatus: null,
                powerDownValidateErrorMessage: null,
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 6 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 14 },
                    }
                }
            }
        },
        computed: {
          freqOptions () {
            return [
                {"key":300,"label":"5" + this.$t('global.minute')},
                {"key":600,"label":"10" + this.$t('global.minute')},
                {"key":900,"label":"15" + this.$t('global.minute')},
                {"key":1200,"label":"20" + this.$t('global.minute')},
                {"key":1800,"label":"30" + this.$t('global.minute')},
                {"key":2400,"label":"40" + this.$t('global.minute')},
                {"key":3600,"label":"60" + this.$t('global.minute')}
            ]
          }
        },
        methods:{
            init(){
                this.basicConfigForm = this.$form.createForm(this)
                this.locateFreq = 1800
                this.autoAdjust = true
                this.specialFreqSetting = false
                this.startTime = null
                this.endTime = null
                this.intervalTime = null
                this.powerUpTime = null
                this.powerDownTime = null
                this.rollCallSetting = false
                this.heartSetting = false
            },
            onTimeChange(selectTime){
                if(selectTime){
                    selectTime = moment(selectTime.startOf('minute').valueOf())
                }
            },
            gotoPrevious(){
                this.$emit('gotoPrevious')
            },
            gotoNext(){
                let _this = this
                let param = {}
                param.locateFreq = this.locateFreq
                if(this.autoAdjust){
                    param.autoAdjust = this.autoAdjust
                }
                if(this.specialFreqSetting){
                    let customLocateModel = {}
                    if(this.startTime == null || this.endTime == null){
                        this.specialTimeValidateStatus = 'error'
                        this.specialTimeErrorMessage = '请选择时间区间'
                        setTimeout(function(){
                            _this.specialTimeValidateStatus = "success"
                            _this.specialTimeErrorMessage = null
                        },5000)
                        return;
                    }
                    if(!this.intervalTime){
                        this.specialFreqValidateStatus = 'error'
                        this.specialFreqErrorMessage = '请选择定位频率'
                        setTimeout(function(){
                            _this.specialFreqValidateStatus = "success"
                            _this.specialFreqErrorMessage = null
                        },5000)
                        return;
                    }

                    customLocateModel.startTime =  this.startTime.hour() * 3600 + this.startTime.minute() * 60
                    customLocateModel.endTime =  this.endTime.hour() * 3600 + this.endTime.minute() * 60
                    customLocateModel.intervalTime = this.intervalTime
                    param.customLocate = []
                    param.customLocate.push(customLocateModel)
                }
                if(this.powerUpTime){
                    if(!this.powerDownTime){
                        this.powerDownValidateStatus = 'error'
                        this.powerDownValidateErrorMessage = '请选择定时关机时间'
                        setTimeout(function(){
                            _this.powerDownValidateStatus = "success"
                            _this.powerDownValidateErrorMessage = null
                        },5000)
                        return;
                    }
                    param.autoPowerUp = this.powerUpTime.hour() * 3600 + this.powerUpTime.minute() * 60
                }
                if(this.powerDownTime){
                    if(!this.powerUpTime){
                        this.powerUpValidateStatus = 'error'
                        this.powerUpValidateErrorMessage = '请选择定时开机时间'
                        setTimeout(function(){
                            _this.powerUpValidateStatus = "success"
                            _this.powerUpValidateErrorMessage = null
                        },5000)
                        return;
                    }
                    param.autoPowerDown = this.powerDownTime.hour() * 3600 + this.powerDownTime.minute() * 60
                }
                _this.$emit('gotoNext',param)
            }
        }
    }
</script>